<template>
  <div class="container d-flex fd-column SECTION">
    <div class="h3 text-bold p-x-1:mo p-b-2">
      <div>{{content.title}}</div>
    </div>
    <div class="d-flex w-100 fd-column:mo flex-1-1 TESTIMONIAL-SECTION" >
      <div
          v-for="(testimonial, index) in content.testimonials"
          :key="index"
          class="TESTIMONIAL"
      ><short-testimonial
          :testimonial= testimonial />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ShortTestimonial from './components/ShortTestimonial';

export default {
  name: 'our-cosutomers-say',
  components: {
    ShortTestimonial,
  },

  computed: {

    ...mapGetters('homepage/contentful', [
      'customerHomePage',
    ]),
    content () {
      return this.customerHomePage.testimonialSection;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
  .SECTION {
    margin-bottom: 10 * $unit;
  }
  .TESTIMONIAL-SECTION {
    display: flex;
    flex: 1 1 auto;
  }
  .TESTIMONIAL {
    @include desktop () {
      margin-right: 16px;
    }
  }
  .TESTIMONIAL:nth-child(2) {
      margin-right: 0px;
    }
</style>
